import { useState, useEffect, useCallback, useRef } from 'react';

export function useElementResizeCompute<T>(elementId: string, computeFn: () => T): T | undefined {
  const [value, setValue] = useState<T | undefined>(undefined);
  const observerRef = useRef<ResizeObserver | null>(null);

  const handleResize = useCallback(() => {
    try {
      const result = computeFn();
      setValue(result);
    } catch (error) {
      console.warn('Error in useElementResizeCompute callback:', error);
    }
  }, [computeFn]);

  useEffect(() => {
    const element = document.getElementById(elementId);

    if (!element) {
      console.warn(`Element with id "${elementId}" not found`);
      return;
    }

    // Calculate initial value
    handleResize();

    // Create ResizeObserver
    observerRef.current = new ResizeObserver(() => {
      handleResize();
    });

    // Start observing the element
    observerRef.current.observe(element);

    // Cleanup function
    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
        observerRef.current = null;
      }
    };
  }, [elementId, handleResize]);

  return value;
}
